import { render, staticRenderFns } from "./NewsCreate.vue?vue&type=template&id=a69c6864&scoped=true"
import script from "./NewsCreate.vue?vue&type=script&lang=js"
export * from "./NewsCreate.vue?vue&type=script&lang=js"
import style0 from "./NewsCreate.vue?vue&type=style&index=0&id=a69c6864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69c6864",
  null
  
)

export default component.exports